webpackJsonp([1],{

/***/ 148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('f7-statusbar'), _vm._v(" "), _c('f7-views', [_c('f7-view', {
    attrs: {
      "color-theme": "blue",
      "id": "main-view",
      "navbar-through": "",
      "dynamic-navbar": true,
      "main": ""
    }
  }, [_c('f7-page', {
    attrs: {
      "color-theme": "blue"
    }
  }, [_c('f7-navbar', [_c('f7-nav-title', [_vm._v("Busquemos")])], 1), _vm._v(" "), _c('f7-messages', {
    attrs: {
      "color-theme": "blue"
    }
  }, [_c('p', {
    staticClass: "messages-title"
  }, [_vm._v(_vm._s(_vm.now))]), _vm._v(" "), _vm._l((_vm.messages), function(message, i) {
    return _c('div', {
      key: ("k-" + i),
      staticClass: "messages-message"
    }, [(!message.image) ? _c('f7-message', {
      class: _vm.getType(message.uid),
      attrs: {
        "text": message.text,
        "label": message.label,
        "color": _vm.getType(message.uid) === 'sent' ? 'blue' : '',
        "date": message.date,
        "name": message.index === 0 ? message.name : '',
        "avatar": message.avatar,
        "image": message.image,
        "type": _vm.getType(message.uid),
        "day": message.day,
        "first": message.first,
        "last": message.last,
        "tail": message.last,
        "time": message.time
      },
      on: {
        "click": _vm.onClick,
        "click:text": _vm.onTextClick,
        "click:name": _vm.onNameClick,
        "click:avatar": _vm.onAvatarClick
      }
    }, [_c('div', {
      staticClass: "msg",
      attrs: {
        "slot": "text"
      },
      domProps: {
        "innerHTML": _vm._s(message.text)
      },
      slot: "text"
    }), _vm._v(" "), _c('div', {
      staticClass: "message-date",
      attrs: {
        "slot": "bubble-end"
      },
      slot: "bubble-end"
    }, [_vm._v("\n                " + _vm._s(message.date) + "\n              ")])]) : _vm._e(), _vm._v(" "), (message.image) ? _c('div', {
      staticClass: "message message-received received message-appear-from-bottom",
      class: {
        'message-tail': message.last,
        'message-last': message.last
      }
    }, [_c('div', {
      staticClass: "message-avatar",
      staticStyle: {
        "background-image": "url('https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg')"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message-bubble messages-image"
    }, [_c('a', {
      staticClass: "external",
      attrs: {
        "target": "_blank",
        "rel": "noopener noreferrer",
        "href": message.image
      }
    }, [_c('img', {
      attrs: {
        "loading": "lazy",
        "src": message.image,
        "alt": message.text
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "message-date"
    }, [_vm._v("\n                  " + _vm._s(message.date) + "\n                ")])])]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.options.length > 0) ? _c('div', {
    staticClass: "messages-message opt-wrapper"
  }, _vm._l((_vm.options), function(opt) {
    return _c('button', {
      key: opt.text,
      staticClass: "question-opts message message-received received message-appear-from-bottom",
      on: {
        "click": function($event) {
          return _vm.onSubmit({
            text: opt.text,
            callback: opt.callback_data
          })
        }
      }
    }, [_vm._v("\n              " + _vm._s(opt.text) + "\n            ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('f7-message', {
    attrs: {
      "type": "received",
      "typing": true,
      "first": true,
      "last": true,
      "tail": true,
      "header": "Busquemos está escribiendo...",
      "avatar": "https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('f7-messagebar', {
    ref: "messagebar",
    attrs: {
      "placeholder": "Mensaje",
      "send-link": "Enviar"
    },
    on: {
      "submit": _vm.onSubmit
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onKeyEnter.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(156)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dompurify__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);













/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      name: "Anónimo",
      avatar: "https://s3.amazonaws.com/testing.admin/Header_LandingChatbot_Mobile.jpg",
      uid: "none",
      auth: false,
      text: "",
      loading: false,
      messages: [],
      options: [],
      myMessagebar: null,
      now: new Date().toLocaleDateString("es-MX", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      })
    };
  },
  methods: {
    replaceURLWithHTMLLinks: function replaceURLWithHTMLLinks(text) {
      if (text) {
        var exp = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;

        return text.replace(exp, "<a class='external' href='$1' target='_blank' rel='noopener noreferrer'>$1</a>");
      }

      return;
    },
    openImage: function openImage(imageURL) {
      return window.open(imageURL);
    },
    onClick: function onClick(event) {},
    onAvatarClick: function onAvatarClick() {},
    onTextClick: function onTextClick() {},
    onNameClick: function onNameClick() {},
    onKeyEnter: function onKeyEnter(event) {
      var text = event.target.value;
      if (text.trim().length === 0) return;
      this.myMessagebar.clear();
      this.onSubmit(text);
    },

    onSubmit: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(text, clear) {
        var newMsg, slsMsg, response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, i, m, botMsg;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(text !== "")) {
                  _context.next = 49;
                  break;
                }

                this.myMessagebar.clear();

                newMsg = {
                  index: 0,
                  name: this.name,
                  first: true,
                  last: true,

                  uid: this.uid,
                  text: (typeof text === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(text)) === "object" && text !== null && !Array.isArray(text) ? text.text : text,
                  date: function () {
                    var now = new Date();

                    return now.toLocaleTimeString("es-MX").substring(0, 5);
                  }()
                };
                slsMsg = {
                  update_id: 241625864,
                  message: {
                    message_id: 1700,
                    from: {
                      id: this.uid,
                      is_bot: false,
                      first_name: this.name,
                      last_name: this.name,
                      username: this.name,
                      language_code: "en"
                    },
                    chat: {
                      id: navigator.userAgent,
                      first_name: "-",
                      last_name: "-",
                      username: "anonimo",
                      type: "private"
                    },
                    date: function () {
                      var now = new Date();

                      return now.toLocaleTimeString("es-MX").substring(0, 5);
                    }(),
                    text: (typeof text === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(text)) === "object" && text !== null && !Array.isArray(text) ? text.text : text
                  }
                };

                this.messages.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, newMsg));

                if ((typeof text === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(text)) === "object" && text !== null && !Array.isArray(text)) {
                  slsMsg.callback = text.callback;
                }

                this.options = [];
                response = void 0;

                this.loading = true;
                _context.prev = 9;
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post("https://tee100llqe.execute-api.us-east-1.amazonaws.com/stage/webapp/webhook", slsMsg);

              case 12:
                response = _context.sent;

              case 13:
                _context.prev = 13;

                this.loading = false;
                return _context.finish(13);

              case 16:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 19;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.data.messages.entries());

              case 21:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 34;
                  break;
                }

                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                i = _ref3[0];
                m = _ref3[1];
                botMsg = {
                  index: i,
                  name: "Busquemos",
                  avatar: this.avatar,
                  uid: 345345345,
                  text: __WEBPACK_IMPORTED_MODULE_8_dompurify___default.a.sanitize(this.replaceURLWithHTMLLinks(m.text), {
                    USE_PROFILES: { html: true }
                  }),
                  first: i === 0,
                  last: i === response.data.messages.length - 1,
                  image: m.photo,
                  date: function () {
                    var now = new Date();

                    return now.toLocaleTimeString("es-MX").substring(0, 5);
                  }()
                };

                this.messages.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, botMsg));
                if (m.reply_markup) {
                  this.options = m.reply_markup.inline_keyboard;
                }
                _context.next = 31;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 31:
                _iteratorNormalCompletion = true;
                _context.next = 21;
                break;

              case 34:
                _context.next = 40;
                break;

              case 36:
                _context.prev = 36;
                _context.t0 = _context["catch"](19);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 40:
                _context.prev = 40;
                _context.prev = 41;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 43:
                _context.prev = 43;

                if (!_didIteratorError) {
                  _context.next = 46;
                  break;
                }

                throw _iteratorError;

              case 46:
                return _context.finish(43);

              case 47:
                return _context.finish(40);

              case 48:

                if (typeof clear === "function") {
                  clear();
                }

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9,, 13, 16], [19, 36, 40, 48], [41,, 43, 47]]);
      }));

      function onSubmit(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    getType: function getType(uid) {
      return uid == this.uid ? "sent" : "received";
    },
    signIn: function signIn() {
      var vm = this;
    }
  },
  created: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_8_dompurify___default.a.addHook('afterSanitizeAttributes', function (node) {
                if ('target' in node) {
                  node.setAttribute('target', '_blank');
                  node.setAttribute('rel', 'noopener noreferrer');
                }
              });
              this.$nextTick(function () {
                this.myMessagebar = __WEBPACK_IMPORTED_MODULE_7_jquery__(".messagebar")[0].f7Messagebar;
                this.onSubmit("hola");
                this.messages.shift();
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _ref4.apply(this, arguments);
    }

    return created;
  }()
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_framework7_dist_framework7_esm_bundle_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_framework7_vue_dist_framework7_vue_esm_bundle_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_framework7_dist_css_framework7_min_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_framework7_dist_css_framework7_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_framework7_dist_css_framework7_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_framework7_dist_css_framework7_ios_min_css__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_framework7_dist_css_framework7_ios_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_framework7_dist_css_framework7_ios_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_app_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__app__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_framework7_vue_dist_framework7_vue_esm_bundle_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_framework7_dist_framework7_esm_bundle_js__["a" /* default */]);

var VueFire = __webpack_require__(75);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueFire);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<app/>',

  framework7: {
    root: '#app',
    theme: 'ios',
    touch: {
      disableContextMenu: false,
      tapHold: true
    },
    statusbar: {
      iosOverlaysWebview: true
    },
    clicks: {
      externalLinks: '.external, a[target="_blank"]'
    }

  },

  components: {
    app: __WEBPACK_IMPORTED_MODULE_6__app___default.a
  }
});

/***/ })

},[96]);


// WEBPACK FOOTER //
// js/app.4dfafcc10a69e045bfa9.js